import { render, staticRenderFns } from "./EvaluacionDesempeño.vue?vue&type=template&id=1e2790ee"
import script from "./EvaluacionDesempeño.vue?vue&type=script&lang=js"
export * from "./EvaluacionDesempeño.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports